export default function HeroSection() {
  const handleScroll = (e: React.MouseEvent<HTMLAnchorElement>, href: string) => {
    e.preventDefault();
    const el = document.querySelector(href);
    if (el) {
      el.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <section
      id="home"
      className="relative min-h-[600px] md:min-h-[700px] flex items-start justify-center overflow-hidden"
    >
      <div
        className="absolute inset-0 bg-cover bg-center"
        style={{
          backgroundImage:
            'url(https://static.readdy.ai/image/36fff7c058435a92029a1d7ae462693c/46eb9c7e2725d10842275411b707cdf9.jpeg)',
        }}
      />
      <div className="absolute inset-0 bg-gradient-to-b from-black/50 via-black/35 to-black/55" />

      <div className="relative z-10 w-full px-4 md:px-8 lg:px-12 pt-28 md:pt-32 pb-6 md:pb-10">
        <div className="max-w-4xl mx-auto text-center flex flex-col items-center">
          {/* H1 wraps the logo per SEO best practice for homepage */}
          <h1 className="flex justify-center mb-0">
            <img
              src="https://static.readdy.ai/image/36fff7c058435a92029a1d7ae462693c/fa2dd6dc20055f8052bf5cbdd4a60cb4.png"
              alt="L.M. Webber Enterprises LLC — Bulk Water Delivery & Construction Materials, Union CT"
              className="h-72 w-72 md:h-96 md:w-96 object-contain drop-shadow-lg"
              loading="eager"
              decoding="async"
              fetchPriority="high"
            />
          </h1>

          <p className="font-display text-3xl md:text-5xl lg:text-6xl font-bold text-white leading-tight -mt-6 md:-mt-10 mb-1" style={{textShadow: '0 2px 12px rgba(0,0,0,0.7), 0 1px 3px rgba(0,0,0,0.9)'}}>
            L.M. Webber Enterprises LLC
          </p>

          <h2 className="font-display text-lg md:text-xl lg:text-2xl text-white font-semibold mb-2" style={{textShadow: '0 2px 8px rgba(0,0,0,0.8), 0 1px 3px rgba(0,0,0,1)'}}>
            Bulk Water Delivery &amp; Construction Materials — Union, CT
          </h2>

          <div className="bg-black/40 backdrop-blur-sm rounded-lg px-5 py-3 max-w-2xl mx-auto mb-4">
            <p className="text-sm md:text-base text-white/95 leading-relaxed">
              Serving all of Connecticut, Massachusetts, Rhode Island, and Eastern New York with reliable bulk water delivery for pools, spas, construction sites, and fire departments. We also provide quality construction materials and dump trailer services.
            </p>
          </div>

          <div className="flex flex-col sm:flex-row items-center justify-center gap-4">
            <a
              href="#contact"
              onClick={(e) => handleScroll(e, '#contact')}
              className="bg-accent hover:bg-accent-dark text-white font-medium px-8 py-3.5 rounded-md transition-colors whitespace-nowrap text-sm md:text-base"
            >
              Request a Quote
            </a>
            <a
              href="#services"
              onClick={(e) => handleScroll(e, '#services')}
              className="text-white hover:text-white font-medium px-8 py-3.5 border border-white/60 hover:border-white rounded-md transition-colors whitespace-nowrap text-sm md:text-base"
            >
              View Our Services
            </a>
          </div>

          <div className="mt-8 inline-flex items-center gap-2 bg-white/10 backdrop-blur-sm px-4 py-2 rounded-full">
            <span className="text-white/90 text-xs md:text-sm">Est. 2023</span>
            <span className="text-white/50">|</span>
            <span className="text-white/90 text-xs md:text-sm">Union, CT 06076</span>
          </div>
        </div>
      </div>

      <div className="absolute bottom-6 left-1/2 -translate-x-1/2 animate-bounce">
        <a
          href="#services"
          onClick={(e) => handleScroll(e, '#services')}
          className="text-white/50 hover:text-white/80 transition-colors"
          aria-label="Scroll down"
        >
          <i className="ri-arrow-down-line text-2xl" />
        </a>
      </div>
    </section>
  );
}